import { c as _c } from "react/compiler-runtime";
import { Modal } from '@7f-ui/components/modal/modal';
import { Price } from '@7f-ui/components/price';
import { useIsCartCurrencyMismatch } from '@feat/feat-cart/currency';
import { useState } from 'react';
import { HOTEL_ADS_NAV_ORDER, hotelAdsCriticalPath } from 'src/lib/hotel-ads/nav';
type AppAccommodationRoomRatesModalFooterProps = {
  price: number;
  currency?: string;
  paxLabel: string;
  dateLabel: string;
  onClick: () => Promise<void>;
};
export function AppAccommodationRoomRatesModalFooter(t0) {
  const $ = _c(23);
  const {
    price,
    currency,
    paxLabel,
    dateLabel,
    onClick
  } = t0;
  const [isLoading, setIsLoading] = useState(false);
  const isCurrencyMismatch = useIsCartCurrencyMismatch(currency);
  let t1;
  if ($[0] !== onClick) {
    t1 = async () => {
      setIsLoading(true);
      ;
      try {
        await onClick();
      } catch (t2) {
        const error = t2;
        setIsLoading(false);
        throw error;
      }
    };
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  let t2;
  if ($[2] !== currency || $[3] !== price) {
    t2 = <div><span className="font-body-copy font-semibold"><Price amount={price} currency={currency} /></span>{" inkl. MwSt."}</div>;
    $[2] = currency;
    $[3] = price;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== dateLabel) {
    t3 = <span className="font-body-small">{dateLabel} {" / "}</span>;
    $[5] = dateLabel;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== paxLabel) {
    t4 = <span className="font-body-small">{paxLabel}</span>;
    $[7] = paxLabel;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="font-body-small">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <Modal.Footer.InfoBox>{t2}{t5}</Modal.Footer.InfoBox>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = hotelAdsCriticalPath(HOTEL_ADS_NAV_ORDER.addToCart);
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== handleClick || $[17] !== isCurrencyMismatch || $[18] !== isLoading) {
    t8 = <Modal.Footer.Actions><Modal.Footer.Button onClick={handleClick} isLoading={isLoading} disabled={isCurrencyMismatch} {...t7}>In den Warenkorb</Modal.Footer.Button></Modal.Footer.Actions>;
    $[16] = handleClick;
    $[17] = isCurrencyMismatch;
    $[18] = isLoading;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <Modal.Footer>{t6}{t8}</Modal.Footer>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}